var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76269 1.68983C10.3585 0.820475 11.6415 0.820475 12.2373 1.68983L14.4176 4.87109C14.7426 5.34542 15.2213 5.69318 15.7729 5.85577L19.4721 6.94625C20.4831 7.24425 20.8795 8.46445 20.2368 9.29975L17.885 12.3564C17.5344 12.8121 17.3515 13.3748 17.3673 13.9496L17.4734 17.8048C17.5024 18.8583 16.4644 19.6125 15.4714 19.2594L11.8376 17.9672C11.2958 17.7745 10.7042 17.7745 10.1624 17.9672L6.52862 19.2594C5.53561 19.6125 4.49764 18.8583 4.52662 17.8048L4.63265 13.9496C4.64846 13.3748 4.46563 12.8121 4.11497 12.3564L1.76316 9.29975C1.12046 8.46445 1.51693 7.24425 2.52785 6.94625L6.22714 5.85577C6.77871 5.69318 7.25736 5.34541 7.58244 4.87109L9.76269 1.68983Z",
    fill: "url(#paint0_linear_10761_11489)",
    stroke: "url(#paint1_linear_10761_11489)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10761_11489",
    x1: -1,
    y1: 20.1971,
    x2: 26.401,
    y2: 13.9732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10761_11489",
    x1: -0.369928,
    y1: 23.2365,
    x2: -6.57655,
    y2: 4.69683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaractive);
export default __webpack_public_path__ + "static/media/staractive.1df05e2ac5015fd37bac5559a1683e09.svg";
export { ForwardRef as ReactComponent };